// extracted by mini-css-extract-plugin
module.exports = {"img":"CallBackModal-module--img--3N0iH"};